import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';
import IService from '@types_main/iservice';
import { PagedResponse } from '@types_main/paged-response';
import { PagedParams } from '@types_main/paged.params';
import { CustomFieldRequest } from './requests/custom-field.request';
import { CustomFieldResponse } from './responses/custom-field.response';

export class CustomFieldService extends BaseService implements IService<CustomFieldResponse> {
    protected get resourceName(): string {
        return 'crm/custom-fields';
    }

    public async getAll(
        filter?: string,
        params?: PagedParams
    ): Promise<AxiosResponse<PagedResponse<CustomFieldResponse>>> {
        return await this.get<PagedResponse<CustomFieldResponse>>('paginated' + (filter ?? ''), params);
    }

    /// Ativos e arquivados, na ordem de exibição.
    public async getList(): Promise<AxiosResponse<{ data: CustomFieldResponse[] }>> {
        return await this.get('');
    }

    public async getById(id: string): Promise<AxiosResponse<{ data: CustomFieldResponse }>> {
        return await this.get(id);
    }

    public async create(body: CustomFieldRequest): Promise<AxiosResponse<{ data: CustomFieldResponse }>> {
        return await this.post(body);
    }

    public async update(id: string, body: CustomFieldRequest): Promise<AxiosResponse<{ data: CustomFieldResponse }>> {
        return await this.put(id, body);
    }

    public async deleteById(id: string): Promise<AxiosResponse<void>> {
        return await this.delete(id);
    }
}
